import { createAuthRequestInit } from '../utils/auth';
import { API_BASE, getAbsoluteApiUrl } from '../config/api';

export interface ApiGroup {
  id: string;
  userId?: string | null;
  name: string;
  type: string;
  customType?: string | null;
  description?: string | null;
  contactCount: number;
  createdAt: string;
}

export async function createGroup(payload: {
  name: string;
  type: string;
  description?: string;
  customType?: string;
}): Promise<ApiGroup> {
  const res = await fetch(
    `${API_BASE}/groups`,
    createAuthRequestInit(
      {
        method: 'POST',
        body: JSON.stringify(payload)
      },
      true
    )
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to create group');
  }
  const json = await res.json();
  return (json?.data?.group ?? json) as ApiGroup;
}

export async function getGroups(params?: { userId?: string }): Promise<ApiGroup[]> {
  const url = new URL(getAbsoluteApiUrl('/groups'));
  if (params?.userId) url.searchParams.set('userId', params.userId);
  const res = await fetch(url.toString(), createAuthRequestInit());
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to load groups');
  }
  const json = await res.json();
  return (json?.data?.groups ?? []) as ApiGroup[];
}

export async function updateGroup(
  id: string,
  payload: {
    name: string;
    type: string;
    description?: string;
    customType?: string;
  }
): Promise<ApiGroup> {
  const res = await fetch(
    `${API_BASE}/groups/${id}`,
    createAuthRequestInit(
      {
        method: 'PUT',
        body: JSON.stringify(payload)
      },
      true
    )
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to update group');
  }
  const json = await res.json();
  return (json?.data?.group ?? json) as ApiGroup;
}

export async function deleteGroup(id: string): Promise<void> {
  const res = await fetch(
    `${API_BASE}/groups/${id}`,
    createAuthRequestInit({
      method: 'DELETE'
    })
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to delete group');
  }
}


